var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon404(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 178,
    viewBox: "0 0 161 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_2017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2319 116.248C95.3761 116.248 107.653 103.971 107.653 88.8267C107.653 73.6825 95.3761 61.4058 80.2319 61.4058C65.0878 61.4058 52.811 73.6825 52.811 88.8267C52.811 103.971 65.0878 116.248 80.2319 116.248Z",
    fill: "#0AD1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2316 77.3311C75.7288 77.3311 71.7876 80.3596 70.6222 84.7148C69.4568 89.0701 71.4934 93.4462 75.2574 95.9209C76.4918 96.7324 76.6006 100.431 76.6006 100.431V102.846C76.6006 104.992 77.3766 105.63 80.2316 105.69C83.0866 105.63 83.8631 104.992 83.8631 102.846V100.431C83.8631 100.431 83.9719 96.7324 85.2062 95.9209C88.9703 93.4462 91.0069 89.0701 89.8415 84.7148C88.6761 80.3596 84.7343 77.3311 80.2316 77.3311Z",
    fill: "url(#paint0_linear_35_2017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2318 100.432V92.1982L76.3522 85.4695",
    stroke: "#1B659D",
    strokeWidth: 2.1673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2318 100.432V92.1984L82.6112 90.1929",
    stroke: "#1B659D",
    strokeWidth: 2.1673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6006 100.432V102.846C76.6006 104.992 77.3766 105.63 80.2316 105.69C83.0867 105.63 83.8631 104.992 83.8631 102.846V100.432H80.2316H76.6006Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2319 74.8094V72.9417",
    stroke: "#1B659D",
    strokeWidth: 2.1673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5624 76.5081L87.4949 74.8906",
    stroke: "#1B659D",
    strokeWidth: 2.1673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1965 81.1482L92.8118 80.2144",
    stroke: "#1B659D",
    strokeWidth: 2.1673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9015 76.5081L72.9689 74.8906",
    stroke: "#1B659D",
    strokeWidth: 2.1673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2674 81.1482L67.6521 80.2144",
    stroke: "#1B659D",
    strokeWidth: 2.1673,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2317 46.516C91.5419 46.516 100.711 37.3473 100.711 26.037C100.711 14.7268 91.5419 5.55811 80.2317 5.55811C68.9214 5.55811 59.7527 14.7268 59.7527 26.037C59.7527 37.3473 68.9214 46.516 80.2317 46.516Z",
    fill: "#DDE7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1775 13.1516H91.0855V27.13H82.1775V13.1516Z",
    fill: "#E4555F",
    stroke: "#1B659D",
    strokeWidth: 1.05656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4993 14.0671C83.0088 13.8873 83.2777 13.3316 83.0999 12.826C82.9222 12.3203 82.3651 12.0563 81.8557 12.2361C81.3462 12.416 81.0773 12.9717 81.2551 13.4773C81.4328 13.9829 81.9899 14.247 82.4993 14.0671Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4074 14.0669C91.9168 13.887 92.1858 13.3313 92.008 12.8257C91.8303 12.3201 91.2732 12.056 90.7637 12.2359C90.2543 12.4157 89.9854 12.9714 90.1631 13.477C90.3409 13.9827 90.898 14.2467 91.4074 14.0669Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4074 28.0456C91.9168 27.8658 92.1857 27.3101 92.008 26.8045C91.8303 26.2989 91.2732 26.0348 90.7637 26.2146C90.2543 26.3945 89.9854 26.9502 90.1631 27.4558C90.3409 27.9614 90.898 28.2255 91.4074 28.0456Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4993 28.0454C83.0088 27.8655 83.2777 27.3099 83.0999 26.8042C82.9222 26.2986 82.3651 26.0345 81.8557 26.2144C81.3462 26.3942 81.0773 26.9499 81.2551 27.4555C81.4328 27.9612 81.9899 28.2253 82.4993 28.0454Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0857 30.6504V38.801H68.9767V13.1516H78.2298V30.6504H91.0857Z",
    fill: "#0AD1FF",
    stroke: "#1B659D",
    strokeWidth: 1.05656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4074 31.5657C91.9168 31.3858 92.1857 30.8301 92.008 30.3245C91.8303 29.8189 91.2732 29.5548 90.7637 29.7346C90.2543 29.9145 89.9854 30.4702 90.1631 30.9758C90.3409 31.4814 90.898 31.7455 91.4074 31.5657Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4074 39.7165C91.9168 39.5367 92.1857 38.981 92.008 38.4754C91.8303 37.9698 91.2732 37.7057 90.7637 37.8855C90.2543 38.0654 89.9854 38.6211 90.1631 39.1267C90.3409 39.6323 90.898 39.8964 91.4074 39.7165Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2983 39.7165C69.8078 39.5367 70.0767 38.981 69.8989 38.4754C69.7212 37.9698 69.1641 37.7057 68.6547 37.8855C68.1452 38.0654 67.8763 38.6211 68.0541 39.1267C68.2318 39.6323 68.7889 39.8964 69.2983 39.7165Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5514 31.5657C79.0608 31.3858 79.3297 30.8301 79.152 30.3245C78.9742 29.8189 78.4172 29.5548 77.9077 29.7346C77.3983 29.9145 77.1294 30.4702 77.3071 30.9758C77.4849 31.4814 78.0419 31.7455 78.5514 31.5657Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2983 14.0669C69.8078 13.887 70.0767 13.3313 69.8989 12.8257C69.7212 12.3201 69.1641 12.056 68.6547 12.2359C68.1452 12.4157 67.8763 12.9714 68.0541 13.477C68.2318 13.9827 68.7889 14.2467 69.2983 14.0669Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5516 14.0669C79.061 13.887 79.3299 13.3313 79.1522 12.8257C78.9744 12.3201 78.4173 12.056 77.9079 12.2359C77.3985 12.4157 77.1296 12.9714 77.3073 13.477C77.485 13.9827 78.0421 14.2467 78.5516 14.0669Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1683 39.883L97.177 41.8711L93.2719 32.0078L103.151 35.9067L101.16 37.8948L103.636 40.3676L101.645 42.3557L99.1683 39.883Z",
    fill: "url(#paint1_linear_35_2017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0368 78.0137C37.347 78.0137 46.5158 68.8449 46.5158 57.5347C46.5158 46.2245 37.347 37.0557 26.0368 37.0557C14.7266 37.0557 5.55786 46.2245 5.55786 57.5347C5.55786 68.8449 14.7266 78.0137 26.0368 78.0137Z",
    fill: "#DDE7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8201 58.5119L12.9037 63.3122C12.2619 63.4841 12.1437 63.9226 12.6397 64.2915L21.4613 70.852C21.9573 71.2209 22.8798 71.3805 23.5216 71.2086L41.4379 66.4083C42.0798 66.2363 42.198 65.7979 41.702 65.429L32.8804 58.8684C32.3844 58.4995 31.4619 58.3399 30.8201 58.5119Z",
    fill: "#1B659D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0034 59.3857L14.5451 63.7954C14.238 63.8777 14.1815 64.0874 14.4188 64.2638L19.1293 67.767C19.3666 67.9435 19.8078 68.0199 20.1148 67.9376L36.5731 63.528C36.8802 63.4457 36.9367 63.236 36.6994 63.0595L31.9889 59.5563C31.7516 59.3798 31.3104 59.3035 31.0034 59.3857Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5516 67.5661L29.0499 69.0402C28.7417 69.1228 28.2987 69.0461 28.0606 68.869L26.0263 67.3561C25.7881 67.179 25.8449 66.9684 26.1531 66.8858L31.6548 65.4118C31.963 65.3292 32.4059 65.4059 32.6441 65.583L34.6783 67.0959C34.9165 67.273 34.8598 67.4835 34.5516 67.5661Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8432 42.9081L8.66788 47.7778C8.09754 47.9306 7.75908 48.5168 7.9119 49.0871L11.5427 62.6362C11.6955 63.2065 12.2817 63.5449 12.8521 63.3921L31.0274 58.5225C31.5977 58.3696 31.9362 57.7835 31.7834 57.2132L28.1526 43.664C27.9998 43.0937 27.4135 42.7553 26.8432 42.9081Z",
    fill: "#1B659D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3286 44.1266L9.72299 48.5758C9.3452 48.677 9.121 49.0653 9.22223 49.443L12.4995 61.673C12.6007 62.0508 12.989 62.2749 13.3668 62.1737L29.9725 57.7246C30.3503 57.6234 30.5745 57.2351 30.4733 56.8573L27.196 44.6274C27.0948 44.2496 26.7064 44.0254 26.3286 44.1266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.699 50.7535C17.6444 49.116 19.7383 48.555 21.3759 49.5004C23.0134 50.4458 23.5745 52.5396 22.6291 54.177L20.9172 57.1418L17.9522 55.4301C16.3146 54.4847 15.7535 52.3909 16.699 50.7535Z",
    fill: "url(#paint2_linear_35_2017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9882 53.6746C20.6562 53.4956 21.0526 52.8091 20.8737 52.1411C20.6947 51.4732 20.008 51.0768 19.34 51.2558C18.672 51.4347 18.2755 52.1213 18.4545 52.7893C18.6335 53.4572 19.3202 53.8536 19.9882 53.6746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9901 38.7756C37.5579 38.7756 35.429 40.4115 34.7994 42.7641C34.1699 45.1167 35.27 47.4805 37.3032 48.8172C37.97 49.2556 38.0287 51.2537 38.0287 51.2537V52.5579C38.0287 53.7169 38.4479 54.0619 39.9901 54.0942C41.5323 54.0619 41.9517 53.7169 41.9517 52.5579V51.2537C41.9517 51.2537 42.0105 49.2556 42.6772 48.8172C44.7105 47.4805 45.8106 45.1167 45.181 42.7641C44.5515 40.4115 42.4223 38.7756 39.9901 38.7756Z",
    fill: "url(#paint3_linear_35_2017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.99 51.2539V46.8065L37.8944 43.1719",
    stroke: "#1B659D",
    strokeWidth: 1.05656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9901 51.2538V46.8064L41.2754 45.7231",
    stroke: "#1B659D",
    strokeWidth: 1.05656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0286 51.2537V52.5579C38.0286 53.7169 38.4477 54.0619 39.9899 54.0942C41.5321 54.0619 41.9516 53.7169 41.9516 52.5579V51.2537H39.9899H38.0286Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9901 37.4134V36.4045",
    stroke: "#1B659D",
    strokeWidth: 1.05656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4097 38.331L43.9134 37.4573",
    stroke: "#1B659D",
    strokeWidth: 1.05656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9128 40.8375L46.7853 40.333",
    stroke: "#1B659D",
    strokeWidth: 1.05656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5705 38.331L36.0668 37.4573",
    stroke: "#1B659D",
    strokeWidth: 1.05656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0675 40.8375L33.1949 40.333",
    stroke: "#1B659D",
    strokeWidth: 1.05656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2316 171.959C91.5419 171.959 100.711 162.79 100.711 151.48C100.711 140.169 91.5419 131 80.2316 131C68.9214 131 59.7527 140.169 59.7527 151.48C59.7527 162.79 68.9214 171.959 80.2316 171.959Z",
    fill: "#DDE7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6515 139.497L64.3028 144.884C63.2153 145.511 63.079 146.763 63.9982 147.68L82.5338 166.181C83.453 167.099 85.0797 167.334 86.1672 166.708L95.5159 161.32C96.6034 160.694 96.7397 159.442 95.8205 158.524L77.2849 140.023C76.3657 139.106 74.739 138.87 73.6515 139.497Z",
    fill: "#ECEAE5",
    stroke: "#1B659D",
    strokeWidth: 1.07528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2169 147.4L72.8089 146.524L75.5971 149.265L78.3853 152.006L81.6753 152.928C83.4849 153.436 85.0556 153.883 85.1659 153.921C85.2895 153.964 85.3274 154.191 85.2647 154.513C85.2086 154.8 85.2147 155.136 85.2782 155.259C85.3869 155.471 85.2725 155.554 83.314 156.685L81.2343 157.886L76.4296 153.081L71.625 148.276L72.2169 147.4Z",
    fill: "#E2F5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9782 140.442L75.6567 141.204L70.8331 148.254L81.4441 158.865L89.2726 161.691L90.8758 163.294",
    stroke: "white",
    strokeWidth: 1.07528
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6847 145.909L78.7234 151.948L85.8877 154.808",
    stroke: "white",
    strokeWidth: 1.07528
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3136 155.862C86.989 156.537 88.1844 156.711 88.9835 156.249C89.7825 155.788 89.8827 154.866 89.2073 154.191C88.5318 153.516 87.3365 153.342 86.5374 153.803C85.7383 154.265 85.6381 155.186 86.3136 155.862Z",
    fill: "#DCD9D0",
    stroke: "white",
    strokeWidth: 1.07529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1338 158.555L86.0791 155.7",
    stroke: "white",
    strokeWidth: 1.07528
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8777 142.098L86.8252 154.045",
    stroke: "white",
    strokeWidth: 1.07528
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5588 146.164L70.3728 153.2",
    stroke: "white",
    strokeWidth: 1.07528
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9781 140.442L75.6565 141.204L70.8329 148.254L81.444 158.865L84.4757 164.461L86.0789 166.064",
    stroke: "#FFCB3A",
    strokeWidth: 1.07528
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9519 160.379C84.9531 159.378 86.5764 159.378 87.5776 160.379C88.5787 161.381 88.5787 163.004 87.5776 164.005L85.7647 165.818L83.9519 164.005C82.9508 163.004 82.9508 161.381 83.9519 160.379Z",
    fill: "#E4555F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7646 163.13C86.2825 163.13 86.7023 162.71 86.7023 162.192C86.7023 161.674 86.2825 161.254 85.7646 161.254C85.2468 161.254 84.827 161.674 84.827 162.192C84.827 162.71 85.2468 163.13 85.7646 163.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7143 135.454C75.7155 134.452 77.3387 134.452 78.3399 135.454C79.3411 136.455 79.3411 138.078 78.3399 139.079L76.5271 140.892L74.7143 139.079C73.7131 138.078 73.7131 136.455 74.7143 135.454Z",
    fill: "#5BB535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5272 138.204C77.0451 138.204 77.4649 137.784 77.4649 137.267C77.4649 136.749 77.0451 136.329 76.5272 136.329C76.0094 136.329 75.5895 136.749 75.5895 137.267C75.5895 137.784 76.0094 138.204 76.5272 138.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0684 136.914H95.3533V144.616H97.2601V138.05C97.2601 137.4 96.7431 136.914 96.0684 136.914Z",
    fill: "#00A7CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7631 144.616V144.868C83.7631 145.248 84.0993 145.659 84.5352 145.659H86.6009C86.7602 145.244 87.027 144.882 87.3676 144.608L83.7631 144.616ZM90.4918 144.608C90.8324 144.882 91.0992 145.244 91.2585 145.659H96.1189C96.3266 145.659 96.4938 145.492 96.4938 145.284V144.983C96.4938 144.775 96.3266 144.608 96.1189 144.608H90.4918Z",
    fill: "#596973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8859 138.903V144.161C95.8859 144.798 95.4529 145.275 95.4529 145.764V146.095C95.4529 146.278 95.6004 146.425 95.7836 146.425H96.758H96.8639H97.3102C97.3102 145.35 98.176 144.484 99.2516 144.484C100.327 144.484 101.193 145.35 101.193 146.425H101.745C101.745 145.891 101.575 145.396 101.288 144.989L105.416 145.081V144.808L105.154 144.457C105.081 142.951 103.843 142.61 102.952 141.922C101.843 140.536 100.748 139.028 99.5039 138.903H95.8859Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7631 138.221V144.616H87.2171C87.6643 144.192 88.2673 143.931 88.9297 143.931C89.5922 143.931 90.1951 144.192 90.6423 144.616H95.3534V136.914H84.9924C84.3691 136.906 83.7631 137.298 83.7631 138.221Z",
    fill: "#0AD1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9296 143.931C87.5556 143.931 86.4359 145.051 86.4359 146.425H86.9881C86.9881 145.35 87.854 144.484 88.9296 144.484C90.0052 144.484 90.8712 145.35 90.8712 146.425H91.4233C91.4233 145.051 90.3036 143.931 88.9296 143.931Z",
    fill: "#C5C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8122 139.352L99.7435 139.415C100.445 139.43 102.381 141.891 102.381 141.891H96.8122V139.352Z",
    fill: "#596973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.832 144.497C103.563 144.497 103.306 144.313 103.116 144.123C102.926 143.933 102.819 143.676 102.819 143.407L103.688 143.436C103.936 143.631 103.997 144.028 103.832 144.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.034 144.808C101.447 145.231 101.712 145.798 101.742 146.425H104.874C105.174 146.425 105.416 146.155 105.416 145.82V144.808H101.034Z",
    fill: "#596973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9297 148.252C89.8701 148.252 90.6324 147.489 90.6324 146.549C90.6324 145.609 89.8701 144.846 88.9297 144.846C87.9893 144.846 87.2269 145.609 87.2269 146.549C87.2269 147.489 87.9893 148.252 88.9297 148.252Z",
    fill: "#596973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2517 148.252C100.192 148.252 100.954 147.489 100.954 146.549C100.954 145.609 100.192 144.846 99.2517 144.846C98.3113 144.846 97.549 145.609 97.549 146.549C97.549 147.489 98.3113 148.252 99.2517 148.252Z",
    fill: "#596973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.427 78.0136C145.738 78.0136 154.907 68.8448 154.907 57.5346C154.907 46.2244 145.738 37.0557 134.427 37.0557C123.116 37.0557 113.946 46.2244 113.946 57.5346C113.946 68.8448 123.116 78.0136 134.427 78.0136Z",
    fill: "#DDE7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.169 43.9291L118.82 49.3165C117.733 49.9432 117.596 51.1949 118.515 52.1124L137.051 70.6135C137.97 71.531 139.597 71.7668 140.684 71.1402L150.033 65.7527C151.121 65.1261 151.257 63.8743 150.338 62.9567L131.802 44.4557C130.883 43.5381 129.256 43.3024 128.169 43.9291Z",
    fill: "#FFCB3A",
    stroke: "#1B659D",
    strokeWidth: 1.07528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.27 50.2547C128.102 50.2599 126.332 51.4703 126.143 53.2038C125.929 55.1675 127.825 57.059 130.376 57.4289L134.997 58.0987L135.384 54.5431C135.598 52.5794 133.703 50.6876 131.151 50.3177C130.852 50.2744 130.557 50.2539 130.27 50.2547ZM130.607 52.5503C130.879 52.5523 131.153 52.6059 131.406 52.7063C131.658 52.8067 131.882 52.951 132.059 53.1269C132.203 53.2704 132.312 53.4318 132.379 53.6019C132.447 53.772 132.472 53.9474 132.454 54.1182C132.435 54.289 132.373 54.4518 132.271 54.5973C132.169 54.7428 132.029 54.8681 131.859 54.9661C131.689 55.0642 131.492 55.133 131.28 55.1686C131.068 55.2042 130.844 55.206 130.622 55.1738C130.4 55.1417 130.184 55.0762 129.986 54.9811C129.788 54.886 129.612 54.7633 129.469 54.6197C129.325 54.4762 129.216 54.3148 129.148 54.1447C129.081 53.9746 129.055 53.7991 129.074 53.6283C129.092 53.4575 129.155 53.2948 129.257 53.1493C129.359 53.0038 129.499 52.8785 129.669 52.7805C129.934 52.6279 130.261 52.5475 130.607 52.5503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.018 62.1148L140.612 57.7306",
    stroke: "#1B659D",
    strokeWidth: 1.07528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.956 64.0533L142.55 59.6691",
    stroke: "#1B659D",
    strokeWidth: 1.07528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.895 65.9918L144.488 61.6075",
    stroke: "#1B659D",
    strokeWidth: 1.07528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.954 43.607C159.839 44.4906 159.839 45.9132 158.954 46.7967L147.083 58.6473L143.275 59.2589L143.888 55.4576L155.759 43.607C156.644 42.7234 158.069 42.7235 158.954 43.607Z",
    fill: "url(#paint4_linear_35_2017)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.405 44.958L158.754 49.2969L154.889 53.1553",
    stroke: "#FFCB3A",
    strokeWidth: 1.66031,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0368 140.598C37.347 140.598 46.5158 131.429 46.5158 120.119C46.5158 108.809 37.347 99.6399 26.0368 99.6399C14.7266 99.6399 5.55786 108.809 5.55786 120.119C5.55786 131.429 14.7266 140.598 26.0368 140.598Z",
    fill: "#DDE7EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3953 104.521H37.1477C35.6387 104.521 34.4155 105.744 34.4155 107.253V113.501C34.4155 115.01 35.6387 116.233 37.1477 116.233H43.3953C44.9043 116.233 46.1275 115.01 46.1275 113.501V107.253C46.1275 105.744 44.9043 104.521 43.3953 104.521Z",
    fill: "#0AD1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0406 113.07L38.7138 109.681L41.877 111.827L43.5025 107.684",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3248 113.878C37.7749 113.72 38.0125 113.229 37.8554 112.782C37.6984 112.336 37.2063 112.102 36.7562 112.261C36.3061 112.42 36.0686 112.911 36.2256 113.357C36.3826 113.804 36.8748 114.037 37.3248 113.878Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9979 110.49C39.448 110.331 39.6856 109.84 39.5285 109.394C39.3715 108.947 38.8794 108.714 38.4293 108.873C37.9792 109.032 37.7417 109.522 37.8987 109.969C38.0557 110.416 38.5479 110.649 38.9979 110.49Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1613 112.636C42.6113 112.477 42.8489 111.986 42.6918 111.54C42.5348 111.093 42.0427 110.86 41.5926 111.019C41.1426 111.178 40.905 111.668 41.062 112.115C41.219 112.562 41.7112 112.795 42.1613 112.636Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7869 108.493C44.2369 108.334 44.4745 107.843 44.3175 107.396C44.1604 106.95 43.6683 106.717 43.2182 106.875C42.7682 107.034 42.5306 107.525 42.6877 107.972C42.8447 108.418 43.3368 108.652 43.7869 108.493Z",
    fill: "white",
    stroke: "#1B659D",
    strokeWidth: 1.05656
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7791 106.513L10.4304 111.9C9.34292 112.527 9.20651 113.779 10.1257 114.696L28.6614 133.198C29.5806 134.115 31.2073 134.351 32.2948 133.724L41.6435 128.337C42.7309 127.71 42.8673 126.458 41.9481 125.541L23.4124 107.04C22.4932 106.122 20.8665 105.886 19.7791 106.513Z",
    fill: "#ECEAE5",
    stroke: "#1B659D",
    strokeWidth: 1.07503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3443 114.416L18.9363 113.54L21.7245 116.281L24.5126 119.022L27.8028 119.944C29.6123 120.452 31.1831 120.899 31.2934 120.937C31.417 120.98 31.4549 121.208 31.3921 121.529C31.336 121.816 31.3421 122.152 31.4056 122.275C31.5144 122.487 31.4 122.57 29.4414 123.701L27.3618 124.902L22.5571 120.097L17.7524 115.292L18.3443 114.416Z",
    fill: "#E2F5C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1056 107.459L21.785 108.221L16.9614 115.271L27.5725 125.882L35.401 128.709L37.0042 130.312",
    stroke: "white",
    strokeWidth: 1.07503
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8124 112.925L24.8511 118.964L32.0154 121.825",
    stroke: "white",
    strokeWidth: 1.07503
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4412 122.878C33.1167 123.553 34.3121 123.727 35.1111 123.266C35.9102 122.804 36.0104 121.883 35.3349 121.207C34.6595 120.532 33.4642 120.358 32.6651 120.82C31.866 121.281 31.7658 122.203 32.4412 122.878Z",
    fill: "#DCD9D0",
    stroke: "white",
    strokeWidth: 1.07504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2614 125.571L32.2066 122.716",
    stroke: "white",
    strokeWidth: 1.07503
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0052 109.114L32.9526 121.062",
    stroke: "white",
    strokeWidth: 1.07503
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6862 113.18L16.5003 120.216",
    stroke: "white",
    strokeWidth: 1.07503
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1057 107.458L21.7851 108.221L16.9615 115.271L27.5726 125.882L30.6043 131.478L32.2076 133.081",
    stroke: "white",
    strokeWidth: 1.07503
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9857 116.276C18.6379 115.899 18.7197 115.147 18.1684 114.596C17.6171 114.045 16.6414 113.903 15.9892 114.279C15.337 114.656 15.2552 115.408 15.8065 115.959C16.3579 116.511 17.3335 116.652 17.9857 116.276Z",
    fill: "#5BB535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5624 117.587C24.2146 117.21 24.2964 116.458 23.7451 115.907C23.1938 115.356 22.2181 115.214 21.5659 115.59C20.9137 115.967 20.832 116.719 21.3833 117.27C21.9346 117.822 22.9102 117.963 23.5624 117.587Z",
    fill: "#5BB535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1329 126.788C28.7851 126.411 28.8668 125.659 28.3155 125.108C27.7642 124.556 26.7886 124.415 26.1364 124.791C25.4842 125.168 25.4024 125.92 25.9537 126.471C26.505 127.022 27.4807 127.164 28.1329 126.788Z",
    fill: "#5BB535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0377 129.54C36.6899 129.163 36.7716 128.411 36.2203 127.86C35.669 127.308 34.6934 127.166 34.0411 127.543C33.3889 127.92 33.3072 128.672 33.8585 129.223C34.4098 129.774 35.3855 129.916 36.0377 129.54Z",
    fill: "#E4555F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9164 110.092C22.5686 109.716 22.6504 108.964 22.0991 108.412C21.5478 107.861 20.5721 107.719 19.9199 108.096C19.2677 108.472 19.186 109.225 19.7373 109.776C20.2886 110.327 21.2642 110.469 21.9164 110.092Z",
    fill: "#E4555F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.426 140.598C145.737 140.598 154.905 131.429 154.905 120.119C154.905 108.809 145.737 99.6399 134.426 99.6399C123.116 99.6399 113.948 108.809 113.948 120.119C113.948 131.429 123.116 140.598 134.426 140.598Z",
    fill: "#DDE7EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.913 111.697C152.919 108.699 152.011 107.19 152.011 107.19L152.415 106.585L148.54 106.669L148.889 107.19C148.889 107.19 147.981 108.699 143.987 111.697C142.432 113.154 142.967 117.565 146.541 117.565H154.358C157.932 117.565 158.468 113.154 156.913 111.697V111.697Z",
    fill: "#95D14E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.844 111.45V116.027",
    stroke: "#1B659D",
    strokeWidth: 0.754686
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.09 114.657V111.38C148.09 110.939 148.307 110.728 148.686 110.728C149.143 110.728 149.499 110.845 149.754 111.08C150.008 111.315 150.136 111.599 150.136 111.931C150.136 112.159 150.066 112.381 149.928 112.597C149.789 112.814 149.563 112.967 149.248 113.056L150.214 114.657",
    stroke: "#1B659D",
    strokeWidth: 0.754686
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.872 112.204C152.047 111.991 152.298 111.885 152.624 111.885C152.953 111.885 153.232 111.994 153.459 112.213C153.687 112.429 153.801 112.706 153.801 113.043C153.801 113.381 153.687 113.658 153.459 113.874C153.232 114.09 152.956 114.198 152.633 114.198C152.31 114.198 152.056 114.079 151.872 113.841",
    stroke: "#1B659D",
    strokeWidth: 0.754686
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.889 107.19L146.466 103.565C148.957 103.882 150.288 101.872 151.743 103.864C152.679 105.145 154.608 103.305 154.608 103.305L152.011 107.19",
    fill: "#5BB535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.169 106.513L118.82 111.9C117.732 112.527 117.596 113.779 118.515 114.696L137.051 133.198C137.97 134.115 139.597 134.351 140.684 133.724L150.033 128.337C151.12 127.71 151.257 126.458 150.338 125.541L131.802 107.04C130.883 106.122 129.256 105.886 128.169 106.513Z",
    fill: "#FFCB3A",
    stroke: "#1B659D",
    strokeWidth: 1.07528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.269 112.838C128.101 112.844 126.332 114.054 126.143 115.788C125.929 117.751 127.824 119.643 130.376 120.013L134.997 120.682L135.384 117.127C135.598 115.163 133.702 113.271 131.151 112.901C130.852 112.858 130.557 112.838 130.269 112.838ZM130.606 115.134C130.878 115.136 131.152 115.19 131.405 115.29C131.658 115.39 131.882 115.535 132.058 115.711C132.202 115.854 132.311 116.016 132.379 116.186C132.447 116.356 132.472 116.531 132.453 116.702C132.435 116.873 132.373 117.036 132.27 117.181C132.168 117.326 132.028 117.452 131.858 117.55C131.688 117.648 131.491 117.717 131.279 117.752C131.067 117.788 130.844 117.79 130.622 117.758C130.4 117.725 130.184 117.66 129.986 117.565C129.788 117.47 129.612 117.347 129.468 117.203C129.324 117.06 129.216 116.899 129.148 116.728C129.08 116.558 129.055 116.383 129.073 116.212C129.092 116.041 129.154 115.879 129.256 115.733C129.358 115.588 129.499 115.462 129.669 115.364C129.934 115.212 130.261 115.131 130.606 115.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.018 124.699L140.611 120.315",
    stroke: "#1B659D",
    strokeWidth: 1.07528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.956 126.637L142.55 122.253",
    stroke: "#1B659D",
    strokeWidth: 1.07528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.895 128.576L144.488 124.192",
    stroke: "#1B659D",
    strokeWidth: 1.07528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_2017",
    x1: 64.0509,
    y1: 85.8816,
    x2: 78.4057,
    y2: 78.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5B42D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_2017",
    x1: 94.3179,
    y1: 33.0779,
    x2: 99.807,
    y2: 33.1635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B659D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AD1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_2017",
    x1: 12.5129,
    y1: 45.204,
    x2: 17.0599,
    y2: 49.1772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E7BFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464036,
    stopColor: "#34A5ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADDC44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35_2017",
    x1: 29.5936,
    y1: 40.877,
    x2: 36.5916,
    y2: 37.1434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5B42D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35_2017",
    x1: 136.997,
    y1: 45.4134,
    x2: 153.339,
    y2: 45.4134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AD1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B659D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_2017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.463,
    height: 177.516,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon404);
export default __webpack_public_path__ + "static/media/icon_404.40e36766d41ac0703455b695f7672da2.svg";
export { ForwardRef as ReactComponent };